import { useTranslation } from 'react-i18next'

import { Button, Skeleton } from '@mercai/clever'

import { ProductCard } from '@/components/product-card'

import { generateButtonClasses } from './card-order-products.constants'
import { CardOrderProductsProps } from './card-order-products.type'

import styles from './card-order-products.module.css'

export const CardOrderProducts = ({
  isLoading,
  items,
  selectedProduct,
  setSelectedProduct,
}: CardOrderProductsProps) => {
  const { t } = useTranslation('componentCardsOrderCenterShow')

  return (
    <div className={styles.container}>
      <div className={styles['button-container']}>
        {!isLoading ? (
          items?.map((product, i) => {
            return (
              <Button
                key={`${product?.uuid}-${i}`}
                model="pill"
                variant="primary-outline"
                className={generateButtonClasses(selectedProduct === i)}
                onClick={() => setSelectedProduct(i)}
              >
                {`${t('cardOrderProductsButton')} ${i + 1}`}
              </Button>
            )
          })
        ) : (
          <>
            <Skeleton width="6.125rem" height="2.5rem" />
            <Skeleton width="6.125rem" height="2.5rem" />
            <Skeleton width="6.125rem" height="2.5rem" />
          </>
        )}
      </div>

      {items && items.length > 0 && (
        <ProductCard
          actions={<></>}
          img={
            items?.[selectedProduct]?.catalogProduct?.attributes
              ?.mainImage as string
          }
          title={
            items?.[selectedProduct]?.catalogProduct?.attributes?.title || '-'
          }
          category={
            items?.[selectedProduct]?.catalogProduct?.category?.name || '-'
          }
          density={
            items?.[selectedProduct]?.catalogProduct?.attributes?.density || '-'
          }
          fluidity={
            items?.[selectedProduct]?.catalogProduct?.attributes?.fluidity ||
            '-'
          }
          isLoading={isLoading}
        />
      )}
    </div>
  )
}
